<template>
  <!-- Games section start -->
  <section id="games" class="px-12 lg:px-32 py-16 relative overflow-hidden max-width-container">
    <!-- Text wrapper start -->
    <div class="mb-8">
      <!-- Main text start -->
      <h1 class="uppercase text-3xl mb-4 font-semibold">Játékok</h1>
      <p class="mx-auto text-stone-500 text-justify">
        Fedezze fel a <span class="font-semibold">Mozgásban Maradók Egyesületének</span> egyedülálló ügyességi és
        fejlesztő játékait, amelyek garantáltan
        feldobják bármilyen rendezvény hangulatát!
        Ezek a játékok nemcsak szórakoztatóak, hanem fejlesztik a <span class="font-semibold">csapatmunkát</span>, az
        <span class="font-semibold">egyensúlyt</span>, a <span class="font-semibold">stratégiai gondolkodást</span>
        és az <span class="font-semibold">ügyességet</span> is.
        Ideális választás <span class="font-semibold">céges rendezvényekre</span>, <span class="font-semibold">családi
          napokra</span>, <span class="font-semibold">fesztiválokra</span> és <span class="font-semibold">iskolai
          eseményekre</span>. Tegye
        felejthetetlenné rendezvényét ezekkel a különleges programokkal, amelyek minden korosztály számára <span
          class="font-semibold">élvezetesek</span>
        és <span class="font-semibold">emlékezetesek</span>!
      </p>
      <p class="mx-auto text-stone-500 mt-4 text-justify">
        Az ügyességi játékok nemcsak szórakozást nyújtanak, hanem elősegítik a <span class="font-semibold">közösségi
          élményeket</span> és a résztvevők
        készségeinek fejlesztését.
        Próbálja ki az izgalmas <span class="font-semibold">Óriás jengát</span>, a könnyed <span
          class="font-semibold">Cornhole-t</span>, a kihívást jelentő <span class="font-semibold">Balance
          boardot</span>, a precizitást
        igénylő <span class="font-semibold">Létrás célbadobást</span> vagy a szórakoztató <span
          class="font-semibold">Labdás célbadobást</span>!
        Ezek a játékok garantáltan <span class="font-semibold">mosolyt csalnak</span> mindenki arcára, miközben <span
          class="font-semibold">aktív kikapcsolódást</span> biztosítanak.
      </p>
      <!-- Main text end -->
    </div>
    <!-- Text wrapper end -->

    <!-- Games start -->
    <div class="flex flex-wrap justify-center gap-8">
      <!-- Game 1: Óriás Jenga -->
      <div class="flex flex-col items-center text-center w-72">
        <img :src="jengaImage" alt="Óriás Jenga" class="mb-4 w-72 h-72 object-cover rounded-lg shadow-lg" />
        <h2 class="uppercase text-2xl font-semibold">Óriás Jenga</h2>
        <p class="text-stone-500">
          Egyensúly és stratégia, amely mindenkit megmozgat. Vajon ki lesz az, aki nem dönti le a tornyot?
        </p>
      </div>

      <!-- Game 2: Cornhole -->
      <div class="flex flex-col items-center text-center w-72">
        <img :src="cornholeImage" alt="Cornhole" class="mb-4 w-72 h-72 object-cover rounded-lg shadow-lg" />
        <h2 class="uppercase text-2xl font-semibold">Cornhole</h2>
        <p class="text-stone-500">
          Könnyed, mégis szórakoztató célbadobós játék, amely garantáltan mosolyt csal mindenki arcára.
        </p>
      </div>

      <!-- Game 3: Balance Board -->
      <div class="flex flex-col items-center text-center w-72">
        <img :src="balanceBoardImage" alt="Balance Board" class="mb-4 w-72 h-72 object-cover rounded-lg shadow-lg" />
        <h2 class="uppercase text-2xl font-semibold">Balance Board</h2>
        <p class="text-stone-500">
          Kihívás a stabilitás és az egyensúly fejlesztésére. Vajon meddig tudsz egyensúlyozni?
        </p>
      </div>

      <!-- Game 4: Létrás célbadobás -->
      <div class="flex flex-col items-center text-center w-72">
        <img :src="ladderTossImage" alt="Létrás célbadobás" class="mb-4 w-72 h-72 object-cover rounded-lg shadow-lg" />
        <h2 class="uppercase text-2xl font-semibold">Létrás célbadobás</h2>
        <p class="text-stone-500">
          Precizitást és ügyességet igénylő játék, amely garantáltan leköti a résztvevők figyelmét.
        </p>
      </div>

      <!-- Game 5: Labdás célbadobás -->
      <div class="flex flex-col items-center text-center w-72">
        <img :src="ballTossImage" alt="Labdás célbadobás" class="mb-4 w-72 h-72 object-cover rounded-lg shadow-lg" />
        <h2 class="uppercase text-2xl font-semibold">Labdás célbadobás</h2>
        <p class="text-stone-500">
          Szórakoztató játék, amely fejleszti a célzást és a pontosságot. Ideális minden korosztály számára.
        </p>
      </div>
    </div>
    <!-- Games end -->

    <!-- Circle start -->
    <div class="bg-green-10 h-72 w-72 rounded-full absolute top-0 -right-20 mt-16 -z-20"></div>
    <!-- Circle end -->
  </section>
  <!-- Games section end -->
</template>

<script>
export default {
  data() {
    return {
      jengaImage: require("@/assets/images/games/jenga.webp"),
      cornholeImage: require("@/assets/images/games/cornhole.webp"),
      balanceBoardImage: require("@/assets/images/games/balance-board.webp"),
      ladderTossImage: require("@/assets/images/games/letras-celbadobo.webp"),
      ballTossImage: require("@/assets/images/games/labdas-celbadobo.webp"),
    };
  },
};
</script>

<style>
/* Egyedi stílusok, ha szükséges */
</style>